import {
  useChatStore,
  usePlayersStore,
  useSessionStore,
} from "@/stores"
import type {
  ChatChannel,
  ChatMessage,
} from "@/types"
export function handleChat(params: ChatMessage) {
  const chatStore = useChatStore();
  const playersStore = usePlayersStore();
  const session = useSessionStore();

  const chatData = params;
  const senderId = chatData.fromId;

  const leftNeighborId = playersStore.leftNeighbor?.id;

  const rightNeighborId = playersStore.rightNeighbor?.id;

  let messageTab: ChatChannel | null = null;
  if (leftNeighborId === senderId) {
    messageTab = "left";
  } else if (rightNeighborId === senderId) {
    messageTab = "right";
  } else if (
    (params.toId === "host" && !session.isPlayerOrSpectator) ||
    params.fromId === "host"
  ) {
    messageTab = "host";
  } else if (!session.isPlayerOrSpectator) {
    messageTab = "whispers";
  }

  if (messageTab) {
    chatStore.receiveMessage(chatData, messageTab);
  } else {
    console.warn("[Chat] Message from unknown neighbor:", senderId);
  }
}
